<template>
  <div class="markPage">
    <Header theme="white" @setScroll="setScroll"></Header>
    <div class="dbbanner">
      <div>{{content.title}}</div>
    </div>
    <div class="container">
      <div>
        <div class="title"><span class="titlename">{{content.title}}</span><span class="english">{{content.secondTitle}}</span>
        </div>
        <div class="conBox">
          <!-- <div class="conItem">
            <span class="label">软件版本：</span><span class="value">{{content.version}}</span>
          </div> -->
          <div class="conItem conItem2">
            <span class="label">发布时间：</span><span class="value">{{content.publishTime ? content.publishTime.slice(0, 10) : content.publishTime}}</span>
          </div>
        </div>
        <div class="content" :style="{ whiteSpace: 'pre-wrap' }">{{content.describe}}</div>
      </div>
      <div class="yybg">
        <img class="yyimg" :src="baseUrl + content.image" alt="" srcset="" />
      </div>

    </div>
    <div class="proposal" v-if="content.appImage || content.downloadUrl || content.appletImage || content.wechatImage || content.phone || content.linkUrl">我们同时为您提供多种方式供选择</div>
    <div class="proposalList">
      <div style="width: 100%;display: flex;flex-wrap: wrap;justify-content: center;">
        <div v-if="content.appImage" class="ht">
          <img class="appImage" :src="baseUrl + content.appImage" alt="" srcset="" />
          <div class="xztitle">扫描二维码下载移动客户端</div>
        </div>
        <div v-if="content.appletImage" class="xzx" @mouseover="handleMouseOver(1)" @mouseout="handleMouseOut(1)">
          <img class="icon" src="../../assets/images/xcxicon.png" alt="" srcset="" />
          <div class="message">扫描二维码下载小程序端</div>
          <div class="xcxBox" v-if="xcxShow">
            <img class="appletImage" :src="baseUrl + content.appletImage" alt="" srcset="" />
          </div>
        </div>
        <div v-if="content.wechatImage" class="xzx" @mouseover="handleMouseOver(2)" @mouseout="handleMouseOut(2)">
          <img class="icon" src="../../assets/images/gzhicon.png" alt="" srcset="" />
          <div class="message">扫描二维码关注公众号</div>
          <div class="xcxBox" v-if="gzhShow">
            <img class="appletImage" :src="baseUrl + content.wechatImage" alt="" srcset="" />
          </div>
        </div>
        <div v-if="content.diagnosisUrl" class="ht" @click="toWebsite(content.diagnosisUrl)">
          <img class="icon" src="../../assets/images/zd@2x.png" alt="" srcset="" />
            <div class="message">
              <a :href="content.diagnosisUrl" target="_blank">在线诊断</a>
            </div>
        </div>
        <div v-if="content.downloadUrl" @click="downloadApk(content.downloadUrl)" class="ht">
          <img class="xzicon" src="../../assets/images/xzicon.png" alt="" srcset="" />
          <div class="xztitle">点击下载apk包</div>
        </div>


        <div v-if="content.phone" class="dh" @mouseover="handleMouseOver(3)" @mouseout="handleMouseOut(3)">
          <img class="icon" src="../../assets/images/dhicon.png" alt="" srcset="" />
          <div class="message">{{content.phone}}</div>
          <div class="xcxBox" v-if="lxrShow && content.qrImage">
            <img class="appletImage" :src="baseUrl + content.qrImage" alt="" srcset="" />
          </div>
        </div>
        <div v-if="content.linkUrl" class="ht" @click="toWebsite(content.linkUrl)">
          <img class="icon" src="../../assets/images/hticon.png" alt="" srcset="" />
            <div class="message">
              <a :href="content.linkUrl" target="_blank">点击登录跳转后台</a>
            </div>
        </div>

        <div v-if="content.videoUrl" class="ht" @click="toWebsite(content.videoUrl)">
          <img class="icon" src="../../assets/images/sp@2x.png" alt="" srcset="" />
            <div class="message">
              <a :href="content.videoUrl" target="_blank">视频课程</a>
            </div>
        </div>
      </div>
    </div>
    <!--页脚-->
    <Footer />
    <MarketDialog ref="marketDialog" :id="id"></MarketDialog>
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import MarketDialog from '@/components/marketDialog.vue'
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    fethPlatformById
  } from '@/api/api'
  export default {
    data() {
      return {
        lxrShow: false,
        gzhShow: false,
        xcxShow: false,
        scroll: 'home',
        id: '',
        content: {},
        baseUrl: serverUrl.baseURL,
        dialogData: false, // 弹窗显隐
      }
    },
    components: {
      Header,
      Footer,
      MarketDialog
    },
    created() {
      this.id = this.$route.query.data
      // this.getArticleById()
      this.getApplicationById()
    },
    methods: {
      downloadApk(href) {
        window.location.href = href
      },
      toWebsite(url) {
        if (url) {
          window.open(url)
        }

      },
      handleMouseOver(data) {

        if (data == 1) {
          this.xcxShow = true
        } else if (data == 2) {
          this.gzhShow = true
        }else if (data == 3) {
          this.lxrShow = true
        }

      },
      handleMouseOut(data) {
        if (data == 1) {
          this.xcxShow = false
        } else if (data == 2) {
          this.gzhShow = false
        }else if (data == 3) {
          this.lxrShow = false
        }
      },
      setScroll(eId) {
        this.scroll = eId
      },
      getApplicationById() {
        fethPlatformById({
          id: this.id
        }).then(res => {
          this.content = res.data
        })
      },
      handleApplay() {
        this.$refs.marketDialog.openDialog(this.content.title)
      }
    }
  }
</script>

<style scoped>
  .markPage {
    /* padding-top: 150px; */
    min-height: 100vh;
    background: #fff;
    /* padding-bottom: 521px; */
  }

  .container {
    width: 1373px;
    margin: 30px auto 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 90px;
  }

  .proposalList {
    width: 1373px;
    margin: 30px auto;
    display: flex;
    justify-content: flex-start;
  }

  .dbbanner {
    width: 100%;
    height: 300px;
    background: url('../../assets/images/dbbanner@2x.png') top center no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 84px;
  }

  .dbbanner>div {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 40px;
    color: #FFFFFF;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .dbbanner>div::after {
    content: ' ';
    /* position: absolute; */
    /* bottom: 0px;
  left: 60px; */
    width: 76px;
    height: 4px;
    background: #FFFFFF;
    margin-top: 20px;
  }

  .title {
    position: relative;
  }

  .english {
    font-family: DIN;
    font-weight: bold;
    font-size: 30px;
    color: #D9DEEB;
    position: absolute;
    top: -20px;
    left: 0px;
    z-index: 2;
  }

  .titlename {
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 40px;
    color: #1E1E1E;
    position: relative;
    z-index: 6;
  }

  .content {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #606D8D;
    line-height: 36px;
  }

  .yybg {
    width: 700px;
    min-width: 700px;
    height: 700px;
    background: url('../../assets/images/yyBg.png') top center no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 40px;
  }

  .yyimg {
    width: 649px;
    height: 565px;
  }

  .proposal {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 40px;
    color: #1E1E1E;
    text-align: center;
  }

  .xz {
    width: 424px;
    height: 578px;
    background: url('../../assets/images/apkbg.png') top center no-repeat;
    background-size: 100% 100%;
  }

  .xz>div {
    width: 424px;
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
  }

  .appImage {
    width: 141px;
    height: 141px;
  }

  .xztitle {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 22px;
    color: #1E1E1E;
    margin: 30px 0 10px;
  }

  .xztitle1 {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #606D8D;
  }

  .xzicon {
    width: 64px;
    height: 78px;
  }

  .xzx {
    width: 320px;
    height: 222px;
    background: url('../../assets/images/smbg.png') top center no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
    position: relative;
    margin: 10px;
  }

  .gzh {
    position: relative;
    width: 320px;
    height: 222px;
    background: url('../../assets/images/smbg.png') top center no-repeat;
    background-size: 100% 100%;
    margin-left: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
  }

  .dh {
    position: relative;
    width: 320px;
    height: 222px;
    background: url('../../assets/images/smbg.png') top center no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
    margin: 10px;
  }

  .ht {
    width: 320px;
    height: 222px;
    background: url('../../assets/images/dhbg.png') top center no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
    margin: 10px;
  }

  .icon {
    width: 80px;
    height: 80px;
  }

  .message, a {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 22px;
    color: #1E1E1E;
    margin-top: 40px;
  }

  .dh>.message {
    font-family: DIN;
    font-weight: bold;
    font-size: 24px;
    color: #1F7ECB;
  }

  .xcxBox {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 320px;
    height: 222px;
    background: #1E1E1E;
    opacity: 0.8;
    position: absolute;
    border-radius: 30px;
    pointer-events: none;
  }

  .appletImage {
    width: 141px;
    height: 141px;
  }

  .conItem{
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #8995A8;
    line-height: 30px;
  }
  .conItem .label {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #8995A8;
  }
  .conItem .value{
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
  }
  .conBox{
    margin: 20px 0 30px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .conItem2{
    /* margin-left: 84px; */
  }
</style>



// WEBPACK FOOTER //
// src/views/market/InsideDetails.vue